// extracted by mini-css-extract-plugin
export var button = "_n8-2";
export var card = "_n8-0";
export var closeButtonContainer = "_n8-3";
export var iconContainer = "_n8-1";